import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { t } from 'i18next'

import { DeleteReservaProdutoService } from '@/features/produtos/services/delete-reserva-produto.service'
import { produtosKeys } from '@/features/produtos/utils/queries'
import { showToast } from '@/shared/lib/sonner'

export const useCancelarReservaProduto = () => {
  const queryClient = useQueryClient()
  return useMutation<
    unknown,
    AxiosError,
    { idResponsavel: string; idProduto: string; idExternoProduto: number },
    unknown
  >({
    mutationFn: async ({ idResponsavel, idProduto }) =>
      new DeleteReservaProdutoService().execute(idResponsavel, idProduto),
    onError: () => {
      showToast({
        variant: 'error',
        message: t('common:errors_gerais.padrao'),
      })
    },
    onSuccess: (_, { idExternoProduto }) => {
      showToast({
        variant: 'success',
        message: t('espelho-de-vendas:detalhes_lote.reserva.modal_cancelar_reserva.sucesso'),
      })
      queryClient.invalidateQueries({ queryKey: produtosKeys.detalheLote(idExternoProduto) })
      queryClient.invalidateQueries({ queryKey: ['produtos', 'lotes-empreendimento'] })
    },
  })
}
